export const getLinkNewTabAttributes = (
  opensInNewTab: boolean,
): Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'color'> =>
  opensInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {}
